export default "__VITE_ASSET__D$UHh5wB__"